
// const script = Object.assign(
//     document.createElement('script'),
//     {
//         async: true,
//         src: 'https://static.parastorage.com/unpkg-semver/wix-recorder@^1/app.bundle.min.js',
//         onload() {
//             console.log(window.wixRecorder);

//             window.wixRecorder.addLabel('pos-shop');

            // window.wixRecorder
            //     .recordUrl() // running in the background
            //     .then(recordUrl => console.log(recordUrl));

//             this.onload = null
//         }
//     }   
// )

// document.head.appendChild(script);

((win, doc) => {
  const script = doc.createElement('script');

  script.async = true;
  script.src = 'https://static.parastorage.com/unpkg-semver/wix-recorder@^1/app.bundle.min.js';

  script.onerror = () => {
    script.onload = script.onerror = null;
  };

  script.onload = () => {
    win.require(['wixRecorder'], (wixRecorder) => {
        console.log('wixRecorder Loaded', wixRecorder)
        wixRecorder.addLabel('pos-shop');
    });

    script.onload = script.onerror = null;
  };

  doc.head.appendChild(script);
})(window, document);
